export class DefaultJournalService {
    /**
     * 수업 일지를 생성한다.
     *
     * - exercises가 비어 있으면 에러를 throw한다.
     * - id와 createdAt은 순수 함수 원칙에 따라 매개변수로 전달받는다.
     *
     * @param input 일지 생성 입력
     * @returns 생성된 Journal 객체
     * @throws Error exercises가 비어 있는 경우
     */
    createJournal(input) {
        if (input.exercises.length === 0) {
            throw new Error("DefaultJournalService.createJournal: exercises가 비어 있습니다. 일지에는 최소 1개 이상의 동작이 필요합니다.");
        }
        return {
            id: input.journalId,
            classId: input.classId,
            instructorId: input.instructorId,
            classType: input.classType ?? input.classFormat,
            isOt: input.isOt ?? false,
            equipments: [...input.equipments],
            exercises: input.exercises.map((e) => ({ ...e })),
            problemList: input.problemList,
            improvements: input.improvements,
            improvementsNeeded: input.improvementsNeeded,
            createdAt: input.createdAt,
            ...(input.notes !== undefined ? { notes: input.notes } : {}),
            ...(input.bodyAnalysis !== undefined ? { bodyAnalysis: input.bodyAnalysis } : {}),
            ...(input.memberGoal !== undefined ? { memberGoal: input.memberGoal } : {}),
            ...(input.instructorMemo !== undefined ? { instructorMemo: input.instructorMemo } : {}),
        };
    }
    /**
     * 템플릿을 기반으로 초기 JournalMovementEntry 배열을 생성한다.
     *
     * - 각 entry의 sets, reps는 0으로 초기화된다.
     * - 빈 defaultMovementIds이면 빈 배열을 반환한다.
     *
     * @param template 일지 템플릿
     * @returns 초기화된 JournalMovementEntry 배열
     */
    createFromTemplate(template) {
        return template.defaultMovementIds.map((id) => ({
            movementId: id,
            sets: 0,
            reps: 0,
        }));
    }
}
//# sourceMappingURL=default-journal-service.js.map